import { useEffect, useRef, useState } from 'react';

export const useContainerSize = (defaultWidth = 0, defaultHeight = 0) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [refIsMounted, setRefIsMounted] = useState(false);
  const [containerSize, setContainerSize] = useState({
    width: defaultWidth,
    height: defaultHeight,
  });

  useEffect(() => {
    const updateContainerSize = () => {
      if (containerRef.current) {
        const { offsetWidth, offsetHeight } = containerRef.current;
        setContainerSize({ width: offsetWidth, height: offsetHeight });

        if (!refIsMounted) setRefIsMounted(true);
      }
    };
    updateContainerSize();

    const resizeObserver = new ResizeObserver(updateContainerSize);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  return {
    containerRef,
    containerSize,
    refIsMounted,
  };
};
